import angular from 'angular';

(function() {
    'use strict';
    var core = angular.module('app.core');

    core.constant(
        'DOCUMENT_FILTER_CONST',
        Object.freeze({
            // Les options permettent d'enrichir les Dtos retournés par le serveur
            option: {
                sellerInfo: 'SELLER_INFO',
                buyerInfo: 'BUYER_INFO'
            }
        })
    );
})();
